/**
 * These constants are just examples on how you can build your application,
 * such as defining the routes that are available.
 * This may include additional information to help craft your UI as you view
 * other pages, such as transitions or whether the menu is still visible.
 */

export const ApplicationSettings = {
  ApplicationId: "939C629A-7684-49E0-8C10-3BECBD52E03B"
};

export const DIET_TYPES = [
  "Vegetarian",
  "Vegan",
  "Dairy free",
  "Halal",
  "Kosher",
  "Low fat",
  "Gluten free"
] as const;

export const ALLERGENS = [
  "Gluten",
  "Wheat",
  "Peanuts",
  "Nuts",
  "Milk",
  "Soy",
  "Fish",
  "Celery",
  "Mustard",
  "Crustaceans",
  "Eggs",
  "Lupin",
  "Molluscs",
  "Sesame seeds",
  "Sulphur dioxide"
] as const;

export const WEEKDAY_KEYS = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday"
] as const;
